import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "../lib/app";
import { errMsg } from "../lib/api";
import { Plain } from "../components/Shell";
import { useT } from "../lib/i18n";

const PICK = [["English", "English", "🇬🇧"], ["हिंदी", "हिंदी", "🇮🇳"], ["मराठी", "मराठी", "🇮🇳"]];

function LangPick({ onPick }) {
  return (
    <div className="relative mt-10 space-y-3" data-testid="login-lang-picker">
      <p className="text-center font-display text-xl font-bold">Choose your app language</p>
      <p className="text-center text-sm text-[#6B6680] -mt-2">ॲपची भाषा निवडा · ऐप की भाषा चुनें</p>
      {PICK.map(([v, l]) => (
        <button key={v} data-testid={`login-lang-${v === "English" ? "en" : v === "मराठी" ? "mr" : "hi"}`} onClick={() => onPick(v)}
          className="ul-card w-full !min-h-[60px] font-display text-2xl font-bold hover:-translate-y-0.5 transition-transform">{l}</button>
      ))}
      <p className="text-center text-sm text-[#6B6680]">You can speak or type in Hindi, English, Marathi or a mix.</p>
    </div>
  );
}

export const Logo = ({ size = 64 }) => <img src="/icons/icon-192.png" alt="UnloadIt" style={{ width: size, height: size }} className="rounded-[22%] shadow-lg" />;

export default function Login() {
  const { signedIn, loading, startDemo, lang, setLang } = useApp();
  const t = useT();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const joinCode = sessionStorage.getItem("ul_join");
  if (signedIn && !loading) return <Navigate to={joinCode ? "/start" : "/"} replace />;
  const pickLang = (v) => { setLang(v); localStorage.setItem("ul_lang_pending", "1"); };
  const demo = async () => {
    setBusy(true);
    try { await startDemo(); nav("/"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Plain>
      <div className="ul-blob w-64 h-64 -top-16 -right-20" style={{ background: "#FFD1E3" }} />
      <div className="ul-blob w-72 h-72 top-40 -left-28" style={{ background: "#D9D2FF" }} />
      <div className="relative flex flex-col items-center text-center pt-16">
        <Logo size={76} />
        <h1 className="font-display text-5xl font-extrabold mt-4">Unload<span className="text-[#FF6FA3]">It</span></h1>
        <p className="text-lg text-[#6B6680] font-semibold mt-1">Don’t carry it alone. Just UnloadIt.</p>
        {joinCode && <p className="mt-4 ul-card px-4 py-2 text-sm font-bold" data-testid="join-hint">You're joining a home with code {joinCode}. Sign in to continue.</p>}
      </div>
      {!lang ? <LangPick onPick={pickLang} /> : (<>
      <div className="relative mt-10 space-y-3">
        <button data-testid="login-change-lang" onClick={() => { localStorage.removeItem("ul_lang"); setLang(""); }} className="block mx-auto text-sm font-bold text-[#6A5AE0]">{t("🌐 Change language")} · {lang}</button>
        <button data-testid="login-google-btn" onClick={() => nav("/sign-in")} className="ul-btn w-full bg-white border-[1.5px] border-[#E4DEFA] text-[#2A2540]">
          <span className="font-display text-lg text-[#6A5AE0]">G</span> {t("Continue with Google")}
        </button>
        <button data-testid="login-email-btn" onClick={() => nav("/sign-up")} className="ul-btn w-full bg-white border-[1.5px] border-[#E4DEFA] text-[#2A2540]">✉️ {t("Continue with email")}</button>
        <p className="text-center text-sm text-[#6B6680]">{t("Have an account?")} <button data-testid="login-signin-link" className="text-[#6A5AE0] font-bold underline" onClick={() => nav("/sign-in")}>{t("Sign in")}</button></p>
        <div className="flex items-center gap-3 py-2"><span className="h-px bg-[#E4DEFA] flex-1" /><span className="text-xs font-bold text-[#9C97AE]">{t("OR")}</span><span className="h-px bg-[#E4DEFA] flex-1" /></div>
        <button data-testid="try-demo-btn" disabled={busy} onClick={demo} className="ul-btn ul-grad w-full !min-h-[60px] text-lg ul-pulse">
          {busy ? t("Opening the demo home…") : t("✨ Try the demo family")}
        </button>
        <p className="text-center text-xs text-[#6B6680]">{t("Meera, Arjun, Aaji, Riya and Kabir · dummy data · no sign-up")}</p>
        <p className="text-center text-xs text-[#6B6680]">{t("You can speak or type in Hindi, English, Marathi or a mix.")}</p>
      </div>
      </>)}
      <footer className="relative mt-12 text-center text-xs text-[#6B6680] space-x-3">
        <a data-testid="footer-privacy" href="/legal/privacy" className="underline">Privacy Policy</a>
        <a data-testid="footer-terms" href="/legal/terms" className="underline">Terms of Use</a>
        <a href="/legal/contact" className="underline">Contact</a>
        <p className="mt-2">{t("Free for every family · No ads · No payments")}</p>
      </footer>
    </Plain>
  );
}
